import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const executionsApi = createApi({
  reducerPath: 'executionsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL + '/executions',
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem('user');
      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllExecutions: builder.query({
      query: (query) => `?${query}`,
    }),
    getExecutionsByIdWorkflow: builder.query({
      query: ({workflowId = null, query}) => `/workflow/${workflowId}?${query}`,
    }),

  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllExecutionsQuery,
  useGetExecutionsByIdWorkflowQuery
} = executionsApi;
